import Vue from "vue";
import Router from "vue-router";
import routerConfig from "@/config/routes";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: routerConfig
});

// 全局处理 NavigationDuplicated 错误
const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

export default router;
